export default __webpack_public_path__ + "static/media/ca-3-rMIN.cf3030b9.avif";